import { render } from "./testRecord.vue?vue&type=template&id=06a980bd"
import script from "./testRecord.vue?vue&type=script&lang=js"
export * from "./testRecord.vue?vue&type=script&lang=js"

import "./testRecord.vue?vue&type=style&index=0&id=06a980bd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__